import {
  ReportingProductFiltersParamsSuccessListResponse,
  ResponsesReportingProductFilterOptionResponse,
  ResponsesReportingProductFilterResponse,
} from '@genial/services/dist/models';

import { FilterModalTypes } from '../../components/FilterModal';

import { CategoryOption } from './types';

export const normalizeFilterResponse = (
  response: ReportingProductFiltersParamsSuccessListResponse['data']
): ResponsesReportingProductFilterResponse[] => {
  if (!response || response.length < 1) {
    return [];
  }

  const [firstResponse] = response;

  if (firstResponse && firstResponse.productFilter) {
    return firstResponse.productFilter;
  }

  return [];
};

export const normalizeFilters = (
  filters: ResponsesReportingProductFilterResponse[]
): FilterModalTypes.FilterType[] => {
  const normalizeOptions = (
    options: ResponsesReportingProductFilterOptionResponse[]
  ): CategoryOption[] =>
    options.map((option, index) => ({
      label: option.label || `Opção ${index}`,
      value: option.value || `option-${index}`,
    }));

  return filters.map((filter) => ({
    type: 'section',
    title: filter.productFilterAlias || 'Filtro sem nome',
    fieldName: filter.productFilterName || 'emptyFieldName',
    options: normalizeOptions(filter.productFilterOptions || []),
  }));
};
